import * as _ from 'lodash'
import {ASync} from "../PA.Core/Basic/ASync"
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {
    IConnection,
    IDimension, IDimensionDataProvider, IDimensionSelector, IHierarchy, IHierarchyLevel,
    IHierarchyNode, instanceOfIDimensionDataProvider
} from "./PA.Reporting.IF";
import {IProgressProvider} from "../PA.Core/PA.Core.IF.Basic";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {IBusinessObject} from "../PA.Core/PA.Core.IF.BO";

export class DimensionSelector
    implements IDimensionSelector {

    private _dimension: IDimension;
    private _dimensionDataProvider: IDimensionDataProvider;
    private _progressProvider: IProgressProvider

    private _initSelectedHiearchyId: string
    private _initSelectedHiearchyLevelId: string
    private _initSelectedHierarchyNodeIds: string[]
    private _allHierarchies: IHierarchy[];

    private _hierarchies: IHierarchy[];
    private _OnHierarchyChanged: BehaviorSubject<IDimensionSelector>;

    private _hierarchyLevels: IHierarchyLevel[];
    private _OnHierarchyLevelChanged: BehaviorSubject<IDimensionSelector>;

    private _hierarchyNodes: IHierarchyNode[];
    private _OnHierarchyNodesChanged: BehaviorSubject<IDimensionSelector>;

    private _hierarchySelected: IHierarchy;
    private _hierarchyLevelSelected: IHierarchyLevel;
    private _hierarchyNodesSelected: IHierarchyNode[];
    private _OnHierarchySelectedChanged: BehaviorSubject<IDimensionSelector>;
    private _OnHierarchyLevelSelectedChanged: BehaviorSubject<IDimensionSelector>;
    private _OnHierarchyNodesSelectedChanged: BehaviorSubject<IDimensionSelector>;
    private _OnSelectionChanged: BehaviorSubject<IDimensionSelector>;

    private _hierarchySelectedInitialized: boolean
    private _hierarchyLevelSelectedInitialized: boolean
    private _hierarchyNodesSelectedInitialized: boolean

    private _parent: IDimensionSelector;
    private _lockSelectionToParent: boolean;
    private _wbCompanyId: number;
    private _wbSalesOrgId: number;


    _OnLoadComplete: Promise<IBusinessObject>;

    constructor(aDimension: IDimension,
                aDimensionDataProvider: IDimensionDataProvider,
                initHierarchyID?: string,
                initHierarchyNodesIds?: string[],
                parentDimensionSelector?: IDimensionSelector,
                lockSelectionToParent?: boolean,
                wbSalesOrgId?: number) {
        let self = this

        this._dimension = aDimension
        this._dimensionDataProvider = aDimensionDataProvider
        this._initSelectedHiearchyId = initHierarchyID || aDimension.DimensionRenderOptions.defaultHierarchy || ''
        this._initSelectedHierarchyNodeIds = initHierarchyNodesIds || []
        this._hierarchySelectedInitialized = false
        this._hierarchyNodesSelectedInitialized = false
        this._progressProvider = new ProgressProvider(aDimension.DimensionName + " Dimension Selector")

        this._hierarchies = []
        this._OnHierarchyChanged = new BehaviorSubject<IDimensionSelector>(this);

        this._hierarchyLevels = []
        this._OnHierarchyLevelChanged = new BehaviorSubject<IDimensionSelector>(this);

        this._hierarchyNodes = []
        this._OnHierarchyNodesChanged = new BehaviorSubject<IDimensionSelector>(this);

        this._hierarchySelected = undefined
        this._hierarchyNodesSelected = []

        this._OnSelectionChanged = new BehaviorSubject<IDimensionSelector>(this)
        this._OnHierarchySelectedChanged = new BehaviorSubject<IDimensionSelector>(this)
        this._OnHierarchyLevelSelectedChanged = new BehaviorSubject<IDimensionSelector>(this)
        this._OnHierarchyNodesSelectedChanged = new BehaviorSubject<IDimensionSelector>(this);

        this._parent = parentDimensionSelector
        if (_.isEmpty(this._parent)) {
            this._lockSelectionToParent = false
        } else {
            this._lockSelectionToParent = lockSelectionToParent || false
            this.setupParentEventSubscriptions()
        }
        this._allHierarchies = []
        this._wbCompanyId = 0
        this._wbSalesOrgId = wbSalesOrgId


        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.loadHierarchies()
                .then((ignore) => {
                    resolve();
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    get WBCompanyId(): number {
        return this._wbCompanyId
    }

    set WBCompanyId(value: number) {
        this._wbCompanyId = value
        if (this.Hierarchies.length && ((_.isEmpty(this.HierarchySelected) || (!_.isEmpty(this.HierarchySelected) && this.HierarchySelected.WBCompanyId != value)))) {
            this.HierarchySelected = _.first(this.Hierarchies)
            this.HierarchyNodesSelected = []
        }
        if (!this.Hierarchies.length) {
            this._hierarchySelected = undefined
            this._hierarchyNodesSelected = []
            this._hierarchyLevels = []
            this._hierarchyNodes = []
            this.OnHierarchyChanged.next(this)
        }
    }

    get WBSalesOrgId(): number {
        return this._wbSalesOrgId
    }

    set WBSalesOrgId(value: number) {
        this._wbSalesOrgId = value
        if (this.HierarchyNodesSelected.length && (!_.isEmpty(this.HierarchySelected) && this.HierarchySelected.WBSalesOrgId != value))
            this.HierarchyNodesSelected = []

        if (this.Hierarchies.length && ((_.isEmpty(this.HierarchySelected) || (!_.isEmpty(this.HierarchySelected) && this.HierarchySelected.WBSalesOrgId != value)))) {
            this.HierarchySelected = _.first(this.Hierarchies)
            this.HierarchyNodesSelected = []
        }

        if (!this.Hierarchies.length) {
            this._hierarchySelected = undefined
            this._hierarchyNodesSelected = []
            this._hierarchyLevels = []
            this._hierarchyNodes = []
            this.OnHierarchyChanged.next(this)
        }
    }

    get Dimension(): IDimension {
        return this._dimension
    }

    get DimensionDataProvider(): IDimensionDataProvider {
        return this._dimensionDataProvider
    }

    get ProgressProvider(): IProgressProvider {
        return this._progressProvider
    }

    get AllHierarchies(): IHierarchy[] {
        return this._allHierarchies
    }

    get Hierarchies(): IHierarchy[] {
        if (!_.isUndefined(this._wbCompanyId) && this._wbCompanyId > 0) {
            this._hierarchies = _.filter(this._allHierarchies, hierarchy => hierarchy.WBCompanyId === this._wbCompanyId)
            return this._hierarchies
        }

        if (!_.isUndefined(this._wbSalesOrgId) && this._wbSalesOrgId > 0) {
            this._hierarchies = _.filter(this._allHierarchies, hierarchy => hierarchy.WBSalesOrgId === this._wbSalesOrgId)
            return this._hierarchies
        }

        this._hierarchies = this._allHierarchies
        return this._hierarchies
    }

    get OnHierarchyChanged(): BehaviorSubject<IDimensionSelector> {
        return this._OnHierarchyChanged
    }

    get HierarchyLevels(): IHierarchyLevel[] {
        return this._hierarchyLevels
    }

    get OnHierarchyLevelChanged(): BehaviorSubject<IDimensionSelector> {
        return this._OnHierarchyLevelChanged
    }

    get HierarchyNodes(): IHierarchyNode[] {
        return this._hierarchyNodes
    }

    get OnHierarchyNodesChanged(): BehaviorSubject<IDimensionSelector> {
        return this._OnHierarchyNodesChanged
    }

    get HierarchySelected(): IHierarchy {
        return this._hierarchySelected
    }

    set HierarchySelected(value: IHierarchy) {

        if (this._hierarchySelected == value) {
            return
        }
        if ((!_.isEmpty(this._hierarchySelected)) &&
            (!_.isEmpty(value))) {
            if (this._hierarchySelected.HierarchyId == value.HierarchyId) {
                return
            }
        }

        this._hierarchySelected = value
        this._OnSelectionChanged.next(this)
        this._OnHierarchySelectedChanged.next(this)


        // Reload the Nodes..

        this.loadHierarchyLevels()
        this.loadHierarchyNodes()

    }


    get HierarchyLevelSelected(): IHierarchyLevel {
        return this._hierarchyLevelSelected
    }

    set HierarchyLevelSelected(value: IHierarchyLevel) {

        if (this._hierarchyLevelSelected == value) {
            return
        }
        if ((!_.isEmpty(this._hierarchyLevelSelected)) &&
            (!_.isEmpty(value))) {
            if (this._hierarchyLevelSelected.LevelId == value.LevelId) {
                return
            }
        }

        this._hierarchyLevelSelected = value
        this._OnSelectionChanged.next(this)
        this._OnHierarchyLevelSelectedChanged.next(this)
    }

    get HierarchyNodesSelected(): IHierarchyNode[] {
        return this._hierarchyNodesSelected
    }

    set HierarchyNodesSelected(value: IHierarchyNode[]) {
        // confirm the input is an array
        if (!_.isArray(value)) {
            return
        }

        this._hierarchyNodesSelected = value
        this._OnSelectionChanged.next(this)
        this._OnHierarchyNodesSelectedChanged.next(this)
    }


    get OnHierarchySelectedChanged(): BehaviorSubject<IDimensionSelector> {
        return this._OnHierarchySelectedChanged
    }

    get OnHierarchyLevelSelectedChanged(): BehaviorSubject<IDimensionSelector> {
        return this._OnHierarchyLevelSelectedChanged
    }

    get OnHierarchyNodesSelectedChanged(): BehaviorSubject<IDimensionSelector> {
        return this._OnHierarchyNodesSelectedChanged
    }

    get OnSelectionChanged(): BehaviorSubject<IDimensionSelector> {
        return this._OnSelectionChanged
    }


    get LockSelectionToParent(): boolean {
        return this._lockSelectionToParent
    }

    set LockSelectionToParent(value: boolean) {
        if (_.isEmpty(this._parent)) {
            return
        }

        this._lockSelectionToParent = value
        if (this._lockSelectionToParent) {
            this.HierarchySelected = this._parent.HierarchySelected
            this.HierarchyNodesSelected = this._parent.HierarchyNodesSelected
        } else {
            this.OnSelectionChanged.next(this)
        }

    }

    get Parent(): IDimensionSelector {
        return this._parent
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    private loadHierarchies(): Promise<void> {
        const self = this

        if (!instanceOfIDimensionDataProvider(self.DimensionDataProvider)) {
            return ASync.resolve()
        }


        return new Promise<void>((resolve, error) => {

            if (!_.isEmpty(self._parent)) {
                self._allHierarchies = self._parent.AllHierarchies
                foundSelectedKey()
                self._hierarchySelectedInitialized = true
                return resolve()

            }

            self.ProgressProvider.start("Loading Hierarchies")
            self.ProgressProvider.setPercentComplete(0.5)

            self.DimensionDataProvider.getHierarchies()
                .then((hierarchy_set: IHierarchy[]) => {
                    self.ProgressProvider.setPercentComplete(0.8)

                    this._allHierarchies = hierarchy_set
                    let hierarchyFound: IHierarchy = undefined

                    if (this._parent && this._lockSelectionToParent) {
                        self.HierarchySelected = this._parent.HierarchySelected
                    } else {
                        foundSelectedKey()
                    }
                    self.ProgressProvider.finish()
                    resolve()
                }).catch((err) => {
                self.ProgressProvider.exception(err)
                error(err)
            })


        })

        function foundSelectedKey() {
            let hierarchyFound: IHierarchy = undefined
            _.forEach(self.Hierarchies, (aHierarchy: IHierarchy) => {
                if (aHierarchy.HierarchyId == self._initSelectedHiearchyId) {
                    hierarchyFound = aHierarchy
                    return false // stop iterating
                }
            })

            self._hierarchySelectedInitialized = true
            if (!_.isEmpty(hierarchyFound)) {
                self.HierarchySelected = hierarchyFound
            } else if (!_.isEmpty(self.Hierarchies)) {
                self.HierarchySelected = _.first(self.Hierarchies)
            }
        }
    }

    private loadHierarchyLevels(): Promise<void> {
        const self = this

        if (!instanceOfIDimensionDataProvider(self.DimensionDataProvider)) {
            return ASync.resolve()
        }


        return new Promise<void>((resolve, error) => {

            self.ProgressProvider.start("Loading Hierarchy Levels")
            self.ProgressProvider.setPercentComplete(0.5)


            if (self.Parent) {
                self._hierarchyLevels = self.Parent.HierarchyLevels
                foundSelectedLevel()

                return resolve()
            }

            if (_.isEmpty(self._hierarchySelected))
                return resolve()

            let aHierarchyId = self._hierarchySelected.HierarchyId
            self.DimensionDataProvider.getHierarchyLevels(aHierarchyId)
                .then((hierarchy_level_set: IHierarchyLevel[]) => {
                    self.ProgressProvider.setPercentComplete(0.8)

                    this._hierarchyLevels = hierarchy_level_set
                    foundSelectedLevel()
                    self.ProgressProvider.finish()
                    resolve()
                }).catch((err) => {
                self.ProgressProvider.exception(err)
                error(err)
            })


        })

        function foundSelectedLevel() {
            let hierarchyLevelFound: IHierarchyLevel = undefined


            _.forEach(self._hierarchyLevels, (aHierarchyLevel: IHierarchyLevel) => {
                if (aHierarchyLevel.LevelId == self._initSelectedHiearchyLevelId) {
                    hierarchyLevelFound = aHierarchyLevel
                    return false // stop iterating
                }
            })


            self._hierarchyLevelSelectedInitialized = true

            if (!_.isEmpty(hierarchyLevelFound)) {
                self.HierarchyLevelSelected = hierarchyLevelFound
            } else if (!_.isEmpty(self._hierarchyLevels)) {
                self.HierarchyLevelSelected = _.first(self._hierarchyLevels)
            }
        }
    }

    private loadHierarchyNodes(): Promise<void> {
        const self = this

        if ((!instanceOfIDimensionDataProvider(self.DimensionDataProvider)) || _.isEmpty(self._hierarchySelected)) {
            return ASync.resolve()
        }

        return new Promise<void>((resolve, error) => {
            self.ProgressProvider.start("Loading Hierarchy Nodes")
            self.ProgressProvider.setPercentComplete(0.1)

            if (_.isEmpty(self._hierarchySelected))
                return resolve()

            let aHierarchyId = self._hierarchySelected.HierarchyId
            let level_count = 3
            if ('maxLevelCount' in self._dimension.DimensionRenderOptions) {
                let maxLevelCount = self._dimension.DimensionRenderOptions.maxLevelCount
                if (_.isNumber(maxLevelCount)) {
                    level_count = maxLevelCount
                }
            }

            if (self.Parent) {
                self._hierarchyNodes = self.Parent.HierarchyNodes
                foundSelectedNodes()
                self.ProgressProvider.finish()
                if (self._hierarchyNodesSelected.length) {
                    self.OnHierarchyNodesChanged.next(self)
                    return resolve()
                }

            }

            self.DimensionDataProvider.getHierarchyNodes(aHierarchyId, level_count)
                .then((hierarchy_nodes: IHierarchyNode[]) => {
                    // If this is the first time, use initSelectedNodeIts to generated the selected node list.
                    // Otherwise, use the existing selected nodes.

                    self.ProgressProvider.setPercentComplete(0.5)
                    self._hierarchyNodes = hierarchy_nodes
                    foundSelectedNodes()
                    self.ProgressProvider.finish()
                    self.OnHierarchyNodesChanged.next(self)
                    resolve()
                }).catch((err) => {
                self.ProgressProvider.exception(err)
                error(err)
            })


        })

        function foundSelectedNodes() {
            let selectedIds: { [id: string]: any } = {}
            if (!self._hierarchyNodesSelectedInitialized) {
                self._hierarchyNodesSelectedInitialized = true
                selectedIds = _.keyBy(self._initSelectedHierarchyNodeIds, (s) => {
                    return s
                })
            } else {
                if (self._hierarchyNodesSelected.length)
                    selectedIds = _.keyBy(self._hierarchyNodesSelected, (aNode: IHierarchyNode) => {
                        return aNode.NodeId
                    })
            }

            let newSelectedNodes: IHierarchyNode[] = []

            if (self._parent && self._lockSelectionToParent) {
                self.HierarchyNodesSelected = self._parent.HierarchyNodesSelected
            } else {
                _.forEach(self._hierarchyNodes, (aNode: IHierarchyNode) => {
                    if (aNode.NodeId in selectedIds) {
                        newSelectedNodes.push(aNode)
                    }
                })


                self.HierarchyNodesSelected = newSelectedNodes

            }

        }
    }

    private setupParentEventSubscriptions() {
        const self = this

        if (_.isEmpty(this._parent)) {
            return
        }

        this._parent.OnHierarchySelectedChanged.subscribe((aParentDimensionSelector: IDimensionSelector) => {
            if (_.isEmpty(aParentDimensionSelector)) {
                return
            }

            if (!self.LockSelectionToParent) {
                return
            }

            self.HierarchySelected = aParentDimensionSelector.HierarchySelected
        })

        this._parent.OnHierarchyNodesSelectedChanged.subscribe((aParentDimensionSelector: IDimensionSelector) => {
            if (_.isEmpty(aParentDimensionSelector)) {
                return
            }

            if (!self.LockSelectionToParent) {
                return
            }

            self.HierarchyNodesSelected = aParentDimensionSelector.HierarchyNodesSelected
        })

    }

}
